import interim from '../assets/agencyBrand/JM_INTERIM_LEGER.jpg';
import capeneo from '../assets/agencyBrand/JM_CAPENEO_LEGER.jpg';
import sante from '../assets/agencyBrand/JM_CAPENEO_SANTE_LEGER.jpg';
export function agencyBrand(agency) {
  const id = String(agency?._id ?? (typeof agency === 'string' ? agency : ''));
  if (id === '650adee7951dd697c7535e3e') return 'interim';
  if (id === '654a3d82874a059df3f98653') return 'sante';
  if (id === '6533fe25099978decf532a59') return 'capeneo';
  const text = [agency?.name, agency?.nomDossierPld, agency?.town, id].filter(Boolean).join(' ').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  if (String(agency?.nomDossierPld || '').toUpperCase() === 'CAPENEO' || text.trim() === 'capeneo') return 'sante';
  if (/sante|toulouse/.test(text)) return 'sante';
  if (/capeneo|kapeo19|brive/.test(text)) return 'capeneo';
  return 'interim';
}
export const agencyLogo = agency => ({ interim, capeneo, sante })[agencyBrand(agency)];
export const agencyLogoAssets = [interim, capeneo, sante];
